import { Link } from 'react-router-dom';
import type { Company } from '../lib/types';
import { label } from '../lib/format';
import { Pill } from './Pill';

export function CompanyCard({ company }: { company: Company }) {
  return (
    <Link className="card company-card" to={`/companies/${company.slug}`}>
      <div className="company-card__top">
        <div>
          <h3>{company.name}</h3>
          <span>{[company.headquarters.city, company.headquarters.state].filter(Boolean).join(', ') || 'US location unverified'}</span>
        </div>
        <div className="feedback-badge">{company.physicalFeedbackLevel}/5</div>
      </div>
      <p>{company.description}</p>
      <div className="pill-row">
        <Pill value={company.fundingStage} tone="accent" />
        <Pill value={company.reviewStatus} tone={company.reviewStatus === 'verified' ? 'positive' : 'warning'} />
        {company.domains.slice(0, 2).map((domain) => <Pill key={domain} value={domain} />)}
      </div>
      <div className="card__footer"><small>{label(company.cohort)}</small><span>Open profile →</span></div>
    </Link>
  );
}
